import { render, staticRenderFns } from "./costAdd.vue?vue&type=template&id=718514ce&scoped=true&"
import script from "./costAdd.vue?vue&type=script&lang=js&"
export * from "./costAdd.vue?vue&type=script&lang=js&"
import style0 from "./costAdd.vue?vue&type=style&index=0&id=718514ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718514ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718514ce')) {
      api.createRecord('718514ce', component.options)
    } else {
      api.reload('718514ce', component.options)
    }
    module.hot.accept("./costAdd.vue?vue&type=template&id=718514ce&scoped=true&", function () {
      api.rerender('718514ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/costAdd.vue"
export default component.exports